import { Fragment, useEffect, useState } from "react";
import React from "react";

export const MemoTextArea = (props) => {
  const [mdcnMemo, setMdcnMemo] = useState(props.result.mdcnMemo);

  useEffect(() => {
    setMdcnMemo(props.result.mdcnMemo);
  }, [props.result]);
  return (
    <textarea
      className="textarea-box gray"
      style={{ resize: "none" }}
      placeholder="특이사항 및 메모를 입력해주세요"
      // defaultValue={props.result.mdcnMemo}
      value={mdcnMemo && mdcnMemo != "" && mdcnMemo}
      onChange={(e) => setMdcnMemo(e.target.value)}
    />
  );
};
